exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-tile-button {\n  top: 10px !important;\n  right: 15px !important;\n}\n@media (max-width: 500px) {\n.product-tile-button {\n      top: 7px !important;\n      right: 5px !important;\n}\n}\n", ""]);

// exports
